export default __webpack_public_path__ + "static/media/Brazil.957556eb.svg";